var _path, _path2, _path3, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 74,
    viewBox: "0 0 72 74",
    fill: "none",
    className: "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2002 74L23.7974 43.4L36.0002 47.8625L27.3298 74L22.5129 68.5813L13.2002 74Z",
    fill: "#787EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7998 74L48.2026 43.4L35.9998 47.8625L44.6702 74L49.4871 68.5813L58.7998 74Z",
    fill: "#787EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.704 2.81054C34.0578 0.393695 37.9414 0.393694 40.2952 2.81054C41.8332 4.38975 44.1434 4.98925 46.2635 4.38523C49.4831 3.46791 52.8739 5.38252 53.6882 8.62975C54.2226 10.7606 55.9233 12.4289 58.0569 12.9525C61.2998 13.7484 63.2803 17.0994 62.3469 20.3055C61.7341 22.4104 62.347 24.6826 63.934 26.1951C66.3636 28.5107 66.3636 32.3917 63.934 34.7072C62.347 36.2197 61.7341 38.492 62.3469 40.5969C63.2803 43.8029 61.2998 47.1539 58.0569 47.9498C55.9233 48.4734 54.2226 50.1418 53.6882 52.2726C52.8739 55.5198 49.4831 57.4345 46.2635 56.5171C44.1434 55.9131 41.8332 56.5126 40.2952 58.0918C37.9414 60.5087 34.0578 60.5087 31.704 58.0918C30.166 56.5126 27.8558 55.9131 25.7358 56.5171C22.5161 57.4345 19.1254 55.5198 18.311 52.2726C17.7766 50.1418 16.0759 48.4734 13.9424 47.9498C10.6995 47.1539 8.71887 43.8029 9.65229 40.5969C10.2651 38.492 9.65224 36.2197 8.06525 34.7072C5.63566 32.3917 5.63566 28.5107 8.06525 26.1951C9.65224 24.6826 10.2651 22.4104 9.65229 20.3055C8.71887 17.0994 10.6995 13.7484 13.9424 12.9525C16.0759 12.4289 17.7766 10.7606 18.311 8.62975C19.1254 5.38252 22.5161 3.46791 25.7358 4.38523C27.8558 4.98925 30.166 4.38975 31.704 2.81054Z",
    fill: "#FFD469"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.6756,
    cy: 30.7718,
    rx: 19.116,
    ry: 18.9103,
    fill: "#FEBA57"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.8b1be9981ecfe6ea5c954df98fb3eb15.svg";
export { ForwardRef as ReactComponent };